import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              最新文章
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              行业洞察与实战经验
            </h2>
          </div>
          <Link
            to="/category/hangye-zixun"
            className="mt-4 sm:mt-0 inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-500">{article.publishDate}</span>
                  <span className="text-xs text-foreground-500">·</span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 flex-wrap">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}